<template>
  <Tooltip v-if="quota.total != null" :title="$t('Remaining:') + ' ' + quota.remaining ?? 0">
    <small
      class="d-block"
      :class="size === 'sm' ? 'tw:text-xs' : size === 'lg' ? 'tw:text-base' : 'tw:text-sm'"
    >
      {{ $t('Used:') }} {{ quota.used ?? 0 }}/{{ quota.total }}
    </small>
    <UsageIndicator :model-value="Math.round(quota.percentage_used)" />
  </Tooltip>
</template>

<script setup>
import Tooltip from '@/components/ui/Tooltip.vue'
import { UsageIndicator } from "@/shadcn/components/ui/usage-indicator/index.js";

defineProps({
  quota: {
    type: Object,
    required: true
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg'].includes(value)
  }
})
</script>
